var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorldDoodle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_870_343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.0966 109.117C25.2366 109.117 0.939026 84.8197 0.939026 54.9597C0.939026 25.0998 25.2366 0.8022 55.0966 0.8022C84.9565 0.8022 109.254 25.0998 109.254 54.9597C109.254 84.8197 84.9565 109.117 55.0966 109.117ZM55.0966 1.8009C25.7802 1.8009 1.93773 25.6434 1.93773 54.9597C1.93773 84.2761 25.7802 108.119 55.0966 108.119C84.4129 108.119 108.255 84.2635 108.255 54.9597C108.255 25.656 84.4129 1.8009 55.0966 1.8009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5439 109.117C45.5303 109.117 38.4635 85.3254 38.4635 54.9597C38.4635 24.5941 45.5176 0.8022 54.5439 0.8022C63.5701 0.8022 70.6243 24.5941 70.6243 54.9597C70.6243 85.3254 63.5575 109.117 54.5439 109.117ZM54.5439 1.8009C46.3646 1.8009 39.4622 26.149 39.4622 54.9597C39.4622 83.7704 46.3646 108.119 54.5439 108.119C62.7231 108.119 69.6256 83.7704 69.6256 54.9597C69.6256 26.149 62.7105 1.8009 54.5439 1.8009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9373 109.117C37.1743 109.117 23.5211 84.8197 23.5211 54.9597C23.5211 25.0998 37.1616 0.8022 53.9373 0.8022C70.713 0.8022 84.3535 25.0998 84.3535 54.9597C84.3535 84.8197 70.713 109.117 53.9373 109.117ZM53.9373 1.8009C37.7179 1.8009 24.5198 25.6434 24.5198 54.9597C24.5198 84.2761 37.7179 108.119 53.9373 108.119C70.1568 108.119 83.3548 84.2635 83.3548 54.9597C83.3548 25.656 70.1568 1.8009 53.9373 1.8009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9458 109.117C30.7999 109.117 11.1419 84.8197 11.1419 54.9597C11.1419 25.0998 30.7999 0.8022 54.9458 0.8022C79.0916 0.8022 98.7496 25.0998 98.7496 54.9597C98.7496 84.8197 79.1043 109.117 54.9458 109.117ZM54.9458 1.8009C31.3435 1.8009 12.1532 25.6434 12.1532 54.9597C12.1532 84.2761 31.3561 108.119 54.9584 108.119C78.5607 108.119 97.7636 84.2635 97.7636 54.9597C97.7636 25.656 78.548 1.8009 54.9458 1.8009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0966 64.3342C28.8395 64.3342 0.939026 61.0979 0.939026 55.1057C0.939026 49.1135 28.8395 45.8772 55.0966 45.8772C81.3536 45.8772 109.254 49.1135 109.254 55.1057C109.254 61.0979 81.3536 64.3342 55.0966 64.3342ZM55.0966 46.8759C23.7701 46.8759 1.93773 51.212 1.93773 55.1057C1.93773 58.9994 23.7701 63.3355 55.0966 63.3355C86.423 63.3355 108.255 58.9994 108.255 55.1057C108.255 51.212 86.423 46.8759 55.0966 46.8759Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_870_343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108.315,
    height: 108.315,
    fill: "white",
    transform: "translate(0.940216 0.803467)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldDoodle);
export default __webpack_public_path__ + "static/media/worldDoodle.8774c5ed4caaa658cf1fe7046a7e1203.svg";
export { ForwardRef as ReactComponent };